// Copyright (c) Zammo Inc.

import React from 'react';
import Icon from '@iconify/react';
import questionIcon from '@iconify/icons-simple-line-icons/question';

import Tooltip from './index';

type Props = {
  tooltipPosition?: string;
};
export default function URLTooltip({ tooltipPosition }: Props) {
  return (
    <Tooltip trigger={<Icon icon={questionIcon} />} tooltipPosition={tooltipPosition}>
      <div>
        Enter your website URL to provide a richer experience.
        <br />
        We will overlay your webpage to test your chatbot on. Please do not refresh the page.
      </div>
    </Tooltip>
  );
}
